import {WifiOff, RotateCcw} from 'lucide-react';
import {Button} from '@ui/shadcn/button';

/**
 * Полноэкранная страница «Нет интернета». Показывается поверх всего, когда
 * включён офлайн-режим (demo-тумблер в меню профиля / реальная потеря сети).
 */
export const OfflinePage = ({onRetry}: {onRetry: () => void}) => (
  <div
    className='fixed inset-0 flex items-center justify-center bg-[var(--color-background)] px-4'
    style={{zIndex: 900}}
    role='alert'
  >
    <div className='w-full max-w-[420px] flex flex-col items-center text-center gap-4'>
      <span className='w-16 h-16 rounded-2xl bg-[var(--score-bad-soft)] text-[var(--score-bad)] flex items-center justify-center'>
        <WifiOff size={30} />
      </span>
      <div>
        <h1 className='text-lg font-semibold text-[var(--color-foreground)]'>
          Нет подключения к интернету
        </h1>
        <p className='mt-1.5 text-sm text-[var(--color-muted-foreground)] leading-relaxed'>
          Проверьте соединение и попробуйте снова. Часть данных на экране может
          быть устаревшей.
        </p>
      </div>
      <Button type='button' onClick={onRetry}>
        <RotateCcw size={15} />
        Повторить
      </Button>
    </div>
  </div>
);
